import { useRef } from 'react';

export function useRefed<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
